import { InitialState, TableFilter } from "./tableFilter";
import NumericFilter from "../NumericFilter";

class NumericFilterModel extends TableFilter {
  constructor(initialState = undefined) {
    if (initialState === undefined)
      initialState = new InitialState([{ min: "", max: "" }]);
    super(NumericFilter, initialState);
  }
}

export default NumericFilterModel;
